<div class="admin-form popover-container mt-2">
  <div class="page-title">
    <em class="page-title-icon icon-product"></em>
    <h4>Shelf</h4>
  </div>

  <app-tab [routeLinkTabs]="listRoute"></app-tab>
  <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
    <div class="flex-item d-md-flex justify-content-between align-items-center">
      <div class="form-group text-nowrap">
        <button
          type="button"
          class="btn btn-primary col-sm-12"
          *appHasPermission="['shelf_m']"
          (click)="goToCreate()"
        >
          <em class="icon-plus"></em>
          Create Shelf
        </button>
      </div>
      <div class="d-md-flex flex-fill justify-content-end">
        <div class="filter-search-box flex-item form-group ml-md-2">
          <div class="search-box position-relative">
            <input
              type="text"
              formControlName="searchCriteria"
              class="searchCriteria form-control"
              placeholder="{{ 'CJ_PRODUCT.ENTER_KEY_PLACEHOLDER' | translate }}"
              required
              maxlength="50"
              (keyup.backspace)="clearLastKeyUpSearchText($event)"
            />
            <em
              class="icon-close-mini"
              [ngClass]="{ 'd-none': !searchForm.controls['searchCriteria'].value }"
              (click)="clearSearchText()"
            ></em>
            <button class="btn-search" type="submit">
              <em class="icon-search"></em>
            </button>
          </div>
        </div>
        <div class="filter-dropdown flex-item form-group ml-md-2">
          <ng-select
            [items]="shelfStatusList"
            [searchable]="false"
            [clearable]="false"
            class="select-status"
            bindLabel="label"
            bindValue="value"
            formControlName="status"
            (change)="onchangeStatus($event)"
          >
          </ng-select>
        </div>
        <div class="text-nowrap form-group ml-md-2 d-none d-lg-block">
          <button
            class="btn advance-filter-button btn-advance-filter"
            [ngClass]="{ active: isShowAdvanceSearch }"
            type="button"
            (click)="isShowAdvanceSearch = !isShowAdvanceSearch"
          >
            <em class="icon-filter"></em>
            {{ 'ADVANCED_FILTERS' | translate }}
          </button>
          <div
            class="box-dropdown"
            [ngClass]="{ open: isShowAdvanceSearch }"
            (appClickOutside)="onClickedOutside($event)"
            [exclude]="['.btn-advance-filter', '.is-highlighted']"
          >
            <div class="box-dropdown-list advance-filter-dropdown">
              <div class="box-dropdown-body px-4">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="mb-2">
                          {{ 'CJ_PRODUCT.SHELF_TYPE' | translate }}
                        </div>
                        <ng-select
                          placeholder="Please select..."
                          [items]="shelfTypeList"
                          [searchable]="false"
                          [clearable]="true"
                          [multiple]="true"
                          bindLabel="name"
                          bindValue="code"
                          formControlName="shelfType"
                        >
                        </ng-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="mb-2">
                          {{ 'CJ_PRODUCT.REQUEST_TYPE' | translate }}
                        </div>
                        <ng-select
                          placeholder="Please select..."
                          [items]="requestTypeList"
                          [searchable]="false"
                          [clearable]="true"
                          [multiple]="true"
                          bindLabel="label"
                          bindValue="value"
                          formControlName="requestType"
                        >
                        </ng-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-2">Requested Date</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{ 'FROM' | translate }}</label>
                        <input
                          id="requestedDateFrom"
                          formControlName="requestedDateFrom"
                          type="text"
                          placeholder="{{ environment.dateFormat }}"
                          autocomplete="off"
                          class="form-control calendar"
                          bsDatepicker
                          [bsConfig]="bsDateConfig"
                          [maxDate]="maxDate"
                          (bsValueChange)="onChangeDateFrom($event)"
                          readonly
                        />
                        <label for="requestedDateFrom" class="icon-calendar btn-calendar"></label>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{ 'TO' | translate }}</label>
                        <input
                          id="requestedDateTo"
                          formControlName="requestedDateTo"
                          type="text"
                          placeholder="{{ environment.dateFormat }}"
                          autocomplete="off"
                          class="form-control calendar"
                          bsDatepicker
                          [bsConfig]="bsDateConfig"
                          [minDate]="minDate"
                          (bsValueChange)="onChangeDateTo($event)"
                          readonly
                        />
                        <label for="requestedDateTo" class="icon-calendar btn-calendar"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="advance-filter-footer text-center">
                <button class="btn btn-standard mr-2" type="button" (click)="onClickedOutside($event)">Cancel</button>
                <button class="btn btn-primary" type="button" (click)="onAdvanceSubmit()">
                  {{ 'APPLY' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div
    class="top-search-criteria space-search-criteria"
    *ngIf="dateStringTag || requestTypeStringTag || shelfTypeStringTag"
  >
    <div class="search-criteria" *ngIf="dateStringTag">
      <a class="remove-criteria" (click)="clearFilterDate()">
        <em class="icon-close"></em>
      </a>
      <span>{{ dateStringTag }}: {{ dateTag }}</span>
    </div>

    <div class="search-criteria" *ngIf="requestTypeStringTag">
      <a class="remove-criteria" (click)="clearFilterRequestType()">
        <em class="icon-close"></em>
      </a>
      <span>{{ requestTypeStringTag }}: {{ requestTypeTag }}</span>
    </div>

    <div class="search-criteria" *ngIf="shelfTypeStringTag">
      <a class="remove-criteria" (click)="clearFilterShelfType()">
        <em class="icon-close"></em>
      </a>
      <span>{{ shelfTypeStringTag }}: {{ shelfTypeTag }}</span>
    </div>

    <div class="d-inline-block">
      <a class="btn clear-btn" (click)="clearAdvanceFilter()">Clear All</a>
    </div>
  </div>

  <ng-container *ngIf="(listState$ | async).totalElements === 0">
    <div class="no-result-container text-center">
      <div class="d-flex justify-content-center">
        <img width="240" height="240" src="/assets/images/not-found.svg" alt="Data not found" />
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="(listState$ | async).totalElements > 0">
    <div class="table-responsive">
      <table id="data-table" class="table table-striped table-bordered table-hover w-100" aria-label="datatable">
        <thead>
          <tr>
            <th class="text-center w-10" scope="col">Request No.</th>
            <th class="text-center w-10" scope="col">Shelf Type</th>
            <th class="text-center w-30" scope="col">Shelf Name</th>
            <th class="text-center w-10" scope="col">Request Type</th>
            <th class="text-center w-15" scope="col">Requested By</th>
            <th class="text-center w-10" scope="col">Requested Date</th>
            <th class="text-center w-10" scope="col">Status</th>
            <th class="text-center w-5" scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let shelfRequest of resultList$ | async; index as i">
            <td (click)="goToView(shelfRequest)">
              {{ shelfRequest.requestNo | dashDisplay: '(None)' }}
            </td>
            <td (click)="goToView(shelfRequest)">
              {{ shelfRequest.shelfType | dashDisplay: '-' }}
            </td>
            <td (click)="goToView(shelfRequest)">
              <app-click-to-copy [text]="shelfRequest.shelfName | dashDisplay"></app-click-to-copy>
            </td>
            <td (click)="goToView(shelfRequest)">
              {{ 'REQUEST_TYPE.' + (shelfRequest.requestType || 'NEW') | translate }}
            </td>
            <td (click)="goToView(shelfRequest)">
              {{ shelfRequest.requestBy | dashDisplay }}
            </td>
            <td class="text-center" (click)="goToView(shelfRequest)">
              {{ shelfRequest.requestedDate | amFromUtc | amLocal | dateDisplay }}
            </td>
            <td
              [ngClass]="getColorStatus(shelfRequest.requestStatus)"
              class="request-status"
              (click)="goToView(shelfRequest)"
            >
              {{ 'SHELF_REQUEST.STATUS.' + shelfRequest.requestStatus | translate }}
            </td>

            <td class="text-center position-relative">
              <a
                href="javascript:void(0)"
                class="btn-more mx-auto"
                [popover]="moreTemplate"
                placement="bottom"
                [adaptivePosition]="false"
                [outsideClick]="true"
                *ngIf="
                  hasEditPermission(shelfRequest.requestStatus) ||
                  (shelfRequest.requestStatus === 'D' && hasDeletePermission()) ||
                  hasCancelPermission() ||
                  (shelfRequest.requestStatus !== 'D' && hasViewHistoryPermission())
                "
              >
                <em class="icon-more"></em>
              </a>
              <ng-template #moreTemplate>
                <button
                  type="button"
                  class="btn btn-link"
                  *ngIf="
                    shelfRequest.requestStatus !== 'CANCELLED' &&
                    shelfRequest.requestStatus !== 'REJECTED' &&
                    shelfRequest.requestStatus !== 'APPROVED' &&
                    hasEditPermission(shelfRequest.requestStatus)
                  "
                  (click)="goToEdit(shelfRequest)"
                >
                  <em class="icon-edit"></em>Edit
                </button>
                <button
                  type="button"
                  class="btn btn-link"
                  *ngIf="shelfRequest.requestStatus === 'DRAFT' && hasDeletePermission()"
                  (click)="deleteShelfRequest(shelfRequest.id)"
                >
                  <em class="icon-delete"></em>Delete
                </button>
                <button
                  type="button"
                  class="btn btn-link"
                  *ngIf="
                    shelfRequest.requestStatus === 'AWAITING_APPROVAL' &&
                    hasCancelPermission(shelfRequest.requestStatus)
                  "
                  (click)="cancelShelfRequest(shelfRequest.requestNo)"
                >
                  <em class="icon-forbidden"></em>Cancel Request
                </button>
                <button
                  type="button"
                  class="btn btn-link"
                  *ngIf="shelfRequest.requestStatus !== 'DRAFT' && hasViewHistoryPermission()"
                  (click)="showHistory(shelfRequest.id, shelfRequest.requestNo)"
                >
                  <em class="icon-history"></em>History
                </button>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--pagination-->
    <app-search-pagination
      [currentPage]="currentPage"
      [pageSize]="pageSize"
      [listState$]="listState$"
      (changePage)="onChangePage($event)"
      (changeRowPerPage)="onChangeRowPerPage($event)"
    >
    </app-search-pagination>
  </ng-container>
</div>
